
angular.module('trainerWebApp.resources')
  .factory('accountService', ['$resource', 'errorHandler', function ($resource, errorHandler) {

  var sessionResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/session');
  var enableAdvancedTierTrialResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/account/advanced-tier-trial/enable');

  return {
    enableAdvancedTierTrial: function(options, resultCb, errorCb) {
      return enableAdvancedTierTrialResource.save(options, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    },
    getAccountInfo: function(options, resultCb, errorCb) {
      return sessionResource.save(options, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    },
    accountInfo: null
  };
}]);
